export default {
  title: 'Plan de Medios',
  mediaChannels: 'Canales de Medios'
}
